import _ from 'lodash';
import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { FORM_ERROR_MAPPING } from 'src/constants';
import { TDropItem } from 'src/types';
import Dropdown from './Dropdown';

interface IDropdownFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  options: TDropItem[];
  disabled?: boolean;
  variant?: 'standard' | 'outlined';
  readOnly?: boolean;
  required?: boolean;
  multiple?: boolean;
}

const DropdownField: FC<IDropdownFieldProps> = ({
  label,
  name,
  options,
  readOnly,
  required,
  placeholder,
  ...props
}) => {
  const {
    formState: { errors },
    clearErrors,
    register,
    setValue,
    trigger,
    unregister,
    watch,
  } = useFormContext();

  const value = watch(name);
  const errorType = _.get(errors, `${name}.type`) as unknown as string;
  const errorMessage = errorType ? FORM_ERROR_MAPPING[errorType] : undefined;

  useEffect(() => {
    register(name, { required });
    setValue(name, value);

    return () => {
      unregister(name);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [register, unregister, name, required]);

  const handleChange = (value: string) => {
    setValue(name, value);
    if (value) {
      clearErrors(name);
    } else {
      trigger(name);
    }
  };

  return (
    <Dropdown
      floating={false}
      label={label}
      labelNoValue={value ? undefined : placeholder}
      name={name}
      onChange={handleChange}
      value={value}
      values={options}
      validation={errorMessage ? 'error' : undefined}
      validationMsg={errorMessage}
      disabled={readOnly}
      required={required}
      {...props}
    />
  );
};

export default DropdownField;
